import AxiosAPI from "./AxiosAPI";


export const fetchStoreLocation = async (storeKey) => {
  try {
    const response = await AxiosAPI.get(`/user/stores/${storeKey}/storelocations`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const fetchAllStoreLocation = async () => {
  try {
    const response = await AxiosAPI.get(`/user/stores/allstorelocations`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const handleAddStoreLocation = async (data) => {
  try {
    console.log("location",data);
    const response = await AxiosAPI.post("/user/stores/storelocations", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add location:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditStoreLocation = async (data, key) => {
  try {
    const response = await AxiosAPI.put(
      `/user/stores/storelocations/${key}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};
export const handleDeleteStoreLocation = async (key) => {
  try {
    const response = await AxiosAPI.delete(
      `/user/stores/storelocations/${key}`
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};



